export default "__VITE_ASSET__93ced5e1__"